import React, { Component } from 'react'
import { connect } from 'react-redux'

import FormHeader from 'components/FormHeader'
import FormFooter from 'components/FormFooter'
import LeftSide from './LeftSide'
import RightSide from './RightSide'
import Deleted from 'components/Deleted'
import Divider from 'material-ui/Divider'

import { doc, dirtyRead } from 'selectors/common'

let select = dirtyRead(
	(state, props) => ({
		application: doc(state, props.id || props.routeParams.id)
	})
)

export class ApplicationForm extends Component{
	render(){
		let { props } = this
		let applicationID = this.props.id || this.props.routeParams.id
		let countColomns = this.props.colspan || 2
		let widthColomns = (this.props.style && this.props.style.width && countColomns)?(this.props.style.width.split('px')[0]/countColomns)-18+"px":"50%"
		return(
			<div
				style={{
					display: "inline-block"
				  , width: "100%"
				  , overflow: "hidden"
				}}
			>
				<FormHeader
					title="Application"
					masterDetail={props.masterDetail || false}
					objectID= {applicationID}
				/>
				{(!this.props.application)?
					<Deleted />
					:
					<div style={{position:"relative", height:"calc(100vh - 64px)", overflowX: "hidden"}}>
						<main style={{minHeight:"calc(100vh - 64px)", display:(countColomns>1)?"flex":"block"}}>
			  				<LeftSide objectID={applicationID} countColomns={countColomns}/>
							{countColomns==1 && <Divider style={{marginTop: "20px"}}/>}
							<RightSide objectID={applicationID} countColomns={countColomns}/>
						</main>
						<div
							style={{
								position:"fixed"
						      , zIndex:"9999"
							  , bottom:"3px"
							  , right:"17px"
							  , boxSizing: "borderBox"
							  , maringRight: "17px"
							}}
						>
							<FormFooter masterDetail={this.props.masterDetail || false} objectID={applicationID} />
						</div>
					</div>
				}
			</div>
		)
	}
}

export default connect(select)(ApplicationForm)



// WEBPACK FOOTER //
// ./src/routes/landlord/applicationForm/index.js